import { BASE_GAP, BASE_MENU_HEIGHT } from '@24i/nxg-core-utils/src/constants';
import { getMargins } from '@24i/nxg-sdk-higgs';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { Theme } from '@24i/nxg-sdk-photon';
import { EpgScreenStyles } from './types';

const PageEpg = (theme: Theme): EpgScreenStyles => ({
    container: {
        flex: 1,
        backgroundColor: theme.color.darkerBlur1.color,
        height: '100%',
        '@media (max-width: 800px)': {
            top: !getTelegramWebApp() ? `${BASE_GAP}px` : 'initial',
        },
        '@media (min-width: 800px)': {
            top: !getTelegramWebApp() ? `${BASE_MENU_HEIGHT}px` : 'initial',
        },
    },
    // @ts-ignore: valid responsive styles; the margin-top is handled in the View
    header: {
        ...getMargins(),
    },
});

export default PageEpg;
